import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import{ GlobalConstants } from '../common/global-constants';

const apiUrl = GlobalConstants.apiURL

@Injectable({
  providedIn: 'root'
})
export class ReportService {

    constructor(private http:HttpClient, private sharedapi:SharedService) { }
    getStatusWiseReport(qString:string)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'reports/get-lead-statuswise-report?'+qString,{headers:webheader})
    }

    getLeadYearlyreport(qString:string)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'reports/get-yearly-lead-report?'+qString,{headers:webheader})
    }

    getOpdYearlyreport(qString:string)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'reports/get-yearly-opd-report?'+qString,{headers:webheader})
    }

    getIpdYearlyreport(qString:string)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'reports/get-yearly-ipd-report?'+qString,{headers:webheader})
    }

    getIpdTransReport(pageno:number,limit:number,qString:string){
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'reports/get-ipd-transaction-report/'+limit+'/'+pageno+'?'+qString,{headers:webheader})
    }

    getLeadKeywordReport(pageno:number,limit:number,qstring:string)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'reports/get-lead-keyword-report/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }

    getTreatmentWiseReport(qString:string)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'reports/get-treatment-wise-report?'+qString,{headers:webheader})
    }

    getMobileLoginReport(pageno:number,limit:number,qString:string)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'reports/get-mobile-login-report/'+limit+'/'+pageno+'?'+qString,{headers:webheader})
    }
    
    //-------------------Opd-feedback-tapping-report--------------------------//
    getOpdfeedbackReportData(qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'reports/get-opd-feedback-report-data'+'?'+qstring, {headers:webheader}) 
    }
    //-------------------Ipd-feedback-tapping-report--------------------------//
      getIpdfeedbackReportData(qstring)
      {
          let webheader = this.sharedapi.getHeaders();
          return this.http.get(apiUrl+'reports/get-ipd-feedback-report-data'+'?'+qstring, {headers:webheader}) 
      }

    getIpdScanBookEmiReport(pageno,limit,qstring,type)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-ipd-scanbook-emi-report/'+type +'/' +limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }
}
